/**
 * Design Library — pattern assembler.
 *
 * Each family lives in its own module; this file only concatenates them, so the
 * catalog scales to hundreds or thousands of patterns by adding data files —
 * never by changing architecture.
 */

import { HERO_PATTERNS } from './heroes';
import { LAYOUT_PATTERNS } from './layouts';
import { SECTION_PATTERNS } from './sections';
import { BLOCK_PATTERNS } from './blocks';
import { COVER_PATTERNS } from './covers';
import { INDUSTRY_PATTERNS } from './industry';

/** Every pattern in the library, in family order. */
export const ALL_PATTERNS = Object.freeze([
  ...LAYOUT_PATTERNS,
  ...HERO_PATTERNS,
  ...SECTION_PATTERNS,
  ...BLOCK_PATTERNS,
  ...COVER_PATTERNS,
  ...INDUSTRY_PATTERNS,
]);
